import AnalyticsPageContext, { AnalyticsPage } from 'contexts/Analytics/analyticsPageContext'
import { removeRegionFromPath } from 'lib/urlUtils'
import { useContext } from 'react'
import { useLocation } from 'react-router'

function useIsHomepage() {
  const pathname = removeRegionFromPath(useLocation().pathname)
  return pathname === '/' || pathname === '/home-preview'
}

export function useIsOldHomePage() {
  return useContext(AnalyticsPageContext) === AnalyticsPage.homepageOld
}

export default useIsHomepage
